module.exports = __webpack_public_path__ + "img/logo.f699fc55.png";